<template>

  <div class="editable-td">
    <div class="editable-td__value" v-if="!isEditMode" v-on:dblclick.prevent="onDoubleClick">
      {{editValue}}
    </div>
    <div class="editable-td__input-holder" v-if="isEditMode" v-on:keydown.enter="onSubmit">
      <input class="editable-td__input" type="text" v-model="editValue">
    </div>
  </div>

</template>


<script type="text/javascript">
  export default {
    name: 'editable-td',
    props: {
      initValue: {
        type: [Number, String],
        required: false,
      },
    },
    data() {
      return {
        editValue: this.initValue,
        isEditMode: false,
      };
    },
    watch: {
      initValue(val) {
        this.editValue = val;
      },
    },
    methods: {
      onDoubleClick() {
        this.isEditMode = true;
      },
      onSubmit() {
        this.isEditMode = false;
        this.$emit('input', this.editValue);
      },
    },
  };
</script>


<style type="text/css">

  .editable-td{
    width: 100%;
    height: 100%;
    position: relative;
    font-size: 15px;
  }


  .editable-td__value {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .editable-td__input-holder {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .editable-td__input{
    box-sizing: border-box;
    width: 100%;
    font-size: 15px;
    padding: 0 0;
    height: 24px;
    line-height: 24px;
    background: #fff;
    box-shadow: none;
    border:none;
    outline:none;

  }

</style>


// WEBPACK FOOTER //
// EditableTD.vue?3e72c816